<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col cols="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <AutocompleteGrade
              v-model="grade"
              clear-icon="mdi-close"
              item-text="title"
              item-value="id"
              label="Khối"
              clearable
              outlined
              dense
              hide-details
              return-object
              @change="gradeChanged"
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <AutocompleteClass
              :filter="classFilter"
              v-model="classes"
              clear-icon="mdi-close"
              label="Lớp"
              clearable
              outlined
              dense
              return-object
              hide-details
              @change="classChanged"
            />
          </v-col>
        </v-row>
        <v-row class="pt-4">
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="code"
              clear-icon="mdi-close"
              label="Mã học sinh"
              flat
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="name"
              label="Tên học sinh"
              return-object
              clearable
              flat
              outlined
              dense
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="status"
              :items="studentStatus"
              clear-icon="mdi-close"
              item-text="title"
              item-value="status"
              label="Chọn trạng thái"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex align-end" cols="12" sm="12" md="2">
        <v-btn class="search-button" :class="{ 'px-2': windowWidth < 1100 }" @click="onFilterChanged" outlined>
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import moment from 'moment'
import { textHelpers } from '@/helpers/TextHelper'
import utils from '@/plugins/utils'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade.vue'

export default {
  components: {
    AutocompleteClass,
    AutocompleteGrade
  },
  data: () => ({
    grade: {},
    show: false,
    status: 'active',
    code: '',
    dob: '',
    name: '',
    classes: [],
    gender: '',
    selectedCourse: [],
    genders: [
      { title: 'Nam', value: 'male' },
      { title: 'Nữ', value: 'female' },
      { title: 'Khác', value: 'other' }
    ],
    classData: '',
    windowWidth: window.innerWidth
  }),
  props: {
    defaultFilters: Object
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    classFilter() {
      return { grade: get(this.grade, 'id') }
    }
  },
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        tags_contains: textHelpers.removeSpaces(utils.clearUnicode(this.name)),
        grade: get(this.grade, 'id'),
        currentClass: get(this.classes, 'id', ''),
        dob_gte: moment(this.dob)
          .startOf('day')
          .toISOString(),
        dob_lte: moment(this.dob)
          .endOf('day')
          .toISOString(),
        tags_contains: textHelpers.removeSpaces(this.code),
        status: this.status,
        gender: this.gender
      })
    },
    classChanged(classData) {
      this.grade = get(classData, 'grade')
    },
    gradeChanged(grade) {
      this.grade = grade
      this.classData = null
      this.student = null
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
  watch: {
    defaultFilters(filters) {
      if (filters) {
        this.code = get(filters, 'code')
      }
    }
  }
}
</script>
